import classnames from "classnames";
import React from "react";

interface IToolbarButtonProps {
  active?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
  className?: string;
  title?: string;
  disabled?: boolean;
}

export const ToolbarButton = ({ active, className, children, ...rest }: IToolbarButtonProps) => {
  return (
    <button className={classnames("slate-toolbar-button", { active }, className)} {...rest}>
      {children}
    </button>
  );
};
